export default __webpack_public_path__ + "static/media/bluetooth.313938f9.svg";